// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Cta-cls1__d0305f865cb621571055{/*!*/}.Cta-cls2__d83ccf7fae97d4f6618f{color:#535366;text-align:left}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Cta-cls1__d0305f865cb621571055",
	"cls2": "Cta-cls2__d83ccf7fae97d4f6618f Cta-cls1__d0305f865cb621571055"
};
export default ___CSS_LOADER_EXPORT___;
